import { createSlice } from '@reduxjs/toolkit';
const { STEPS } = require('../constants/bookingConstants');

const bookingSlice = createSlice({
  name: 'booking',
  initialState: {
    step: STEPS.SELECT_DATE,
    data: {},
  },
  reducers: {
    updateBookingData(state, action) {
      state.data = {
        ...state.data,
        ...action.payload,
      };
    },
    updateStep(state, action) {
      state.step = action.payload;
    },
    jumpToNextStep(state, action) {
      state.step = action.payload.step;
      state.data = {
        ...state.data,
        ...action.payload,
      };
    },
  },
});

export const { updateBookingData, updateStep, jumpToNextStep } =
  bookingSlice.actions;
export default bookingSlice.reducer;
